import React, { useEffect, useState } from 'react'
import { AppHeader } from 'src/business/components'
import {
  SPLPCardsProviderComponent,
  SPLPTopLevelFilterComponent,
} from 'src/consumer/components/ServiceProvidersListingPage/ServiceProvidersListingComponents'
import { selectedTabApiData } from 'src/consumer/components/ServiceProvidersListingPage/TherapistPsychiatristListingPage'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'

const TherapyPsychiatryBusiness = () => {
  const [selectedTabId, setSelectedTabId] = useState('therapist')
  const [plansData, setPlansData] = useState([])

  async function pageSetup() {
    const response = await getDataWithoutParams('/api/subscription-plan/1on1')
    if (response?.status === 200 && response?.data?.length > 0) {
      setPlansData(response?.data)
    }
  }

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <AppHeader heading="1-1 Sessions" />
      <SPLPTopLevelFilterComponent
        selectedTabId={selectedTabId}
        setSelectedTabId={setSelectedTabId}
        options={[
          {
            id: 'therapist',
            label: 'Therapist',
            helpText:
              'Therapy can help you cope with emotional struggles that are making it difficult for you to function well.',
          },
          {
            id: 'psychiatrist',
            label: 'Psychiatrist Rx',
            helpText:
              'A psychiatrist will help you manage your mental health concerns and prescribe medication if necessary.',
          },
          {
            id: 'clinical_psychologist',
            label: 'Clinical Psychologist',
            helpText:
              'Therapy can help you cope with emotional struggles that are making it difficult for you to function well.',
          },
        ]}
        primaryHeading="Who do you want to consult?"
        actionText="Have Questions?"
        actionTextAnchor="faq-modal-open"
        actionTextFaqDomain="therapy"
      />
      {/* second level filtering component that will also change the api to be fired by cards provider */}
      <SPLPCardsProviderComponent
        apiCall={selectedTabApiData?.[selectedTabId]}
        plansData={plansData}
        showPriceFromPlansData={true}
        twoColumnDesign={false}
        fromBusiness={true}
      />
      {/* need help or an ad */}
      {/* <SPLPCardsProviderComponent /> */}
      {/* faq */}
      {/* footer */}
    </>
  )
}

export default TherapyPsychiatryBusiness
